export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_mariocnpi.png",
      alt: "Nome da extensão",
    },
    title: "AutoSync",
    text: ["Operações de um Trader Profissional na sua conta"],
    testimonial: {
      text: "Nada supera um bom gerenciamento ",
      author: {
        name: "Mário Vilas Boas, Analista CNPI ",
      },
    },
  },
  stats: {
    title: "Alguns números do Mário CNPI ",
    subtitle: "Analista certificado pela Apimec .",
    data: [
      {
        value: "5",
        description: "Anos de certificação",
      },
      {
        value: "10",
        description: "Anos como trader",
      },
      {
        value: "+1000",
        description: "Alunos",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs do Mário CNPI?",
    subtitle: "Veja quais as principais vantagens dos robôs do Mário CNPI",
    data: [
      {
        title: "7 dias para testar",
      },
      {
        title: "100% automatizado",
      },
      {
        title: "Suporte individual",
      },
      {
        title: "Velocidade",
      },
      {
        title: "Liberdade de Tempo",
      },
      {
        title: "Gerenciamento rígido",
      },
    ],
  },
  cta: {
    title: "Ative agora e vamos juntos dominar o mercado",
    subtitle: "Começar agora",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "O Mário CNPI",
    col1: [
      "Mário é analista técnico credenciado (CNPI), professor de finanças e especialista em leitura de fluxo institucional e análise macroeconômica. \n\nEnquanto a maior parte do varejo perde tempo tentando adivinhar movimentos futuros através de setups engessados e puramente gráficos, Mário opera seguindo o motor real do mercado: a macroeconomia global e o rastro do dinheiro das grandes tesourarias institucionais. ",
      "Combinando uma disciplina inegociável, moldada também pela sua rotina no esporte de alto rendimento e o domínio técnico de ferramentas profissionais avançadas, ele decodifica o mercado diariamente para proteger o capital e buscar consistência real de longo prazo. ",
    ],
    col2: [
      "No Copy AutoSync, você não está seguindo um robô programado por amadores ou um aventureiro de internet. Você está espelhando, de forma 100% automática, a estratégia assinada por um profissional de elite do mercado financeiro. \n\n ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos do Mário CNPI",
  },
  strategies: {
    title: "Estratégias Do Mário CNPI",
    heading: "Melhores estratégias para o mercado, diversificação e segurança ",
    subtitle: "A seleção de estratégias e o acompanhamento diário do macro contexto potencializam o resultado ",
  },
};
